import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-remove-from-follow-up-modal',
  imports: [CommonModule, FormsModule],
  templateUrl: './remove-from-follow-up-modal.component.html',
  styles: [`
    .required {
      color: red;
    }
  `]
})
export class RemoveFromFollowUpModalComponent {
  private readonly activeModal = inject(NgbActiveModal);
  opportunityId  = '';
  reason = '';

  get isValid(): boolean {
    return this.reason.trim().length > 0;
  }

  onCancel(): void {
    this.activeModal.dismiss('cancelled');
  }

  onConfirm(): void {
    if (this.isValid) {
      this.activeModal.close({
        opportunityId: this.opportunityId,
        reason: this.reason
      });
    }
  }
}
